document.addEventListener('DOMContentLoaded', () => {
	const accordions = document.querySelectorAll('.iso-accordion');

	accordions.forEach((accordion) => {
		const allowOnlyOne = accordion.getAttribute('data-single-open') === 'true';
		const items = accordion.querySelectorAll('.accordion-item');

		items.forEach((item) => {
			const button = item.querySelector('.accordion-header');

			if (button) {
				button.addEventListener('click', () => {
					const isOpen = item.classList.contains('is-open');

					if (allowOnlyOne) {
						// Fermer tous les autres
						items.forEach((el) => {
							el.classList.remove('is-open');
						});
						// Ouvrir celui-ci seulement s’il était fermé
						if (!isOpen) {
							item.classList.add('is-open');
						}
					} else {
						// Toggle classique
						item.classList.toggle('is-open');
					}
				});
			}
		});
	});
});
